module.exports = __webpack_public_path__ + "static/media/logo_full.879ffbbb.svg";